import { memo } from 'react';
import { createGlobalStyle } from 'styled-components';
import { FontDefinition } from './FontDefinition';
import { ThemeColours } from './ThemeColours';
import { FONT_STACK } from './constants';

const Sheet = createGlobalStyle`
  body {
    /* Overrides a Nextjs default (hiding the content until the scripts have loaded). 
       We do this because we at least want content to be visible if there is a script error, 
       including the upgrade message for unsupported browsers. */
    display: block;
    ${FONT_STACK};
    color: ${ThemeColours.mono700};
    line-height: 1.38;
    font-size: 16px;
    margin: 0;
    padding: 0;
  }

  .scroll-locked {
    overflow: hidden;
    position: relative;
    touch-action: none;

    body & {
      touch-action: none;
    }
  }

  /** Server-render the default display for Material icons */
  .MuiSvgIcon-root {
    fill: currentColor;
    width: 1em;
    height: 1em;
    display: inline-block;
    font-size: 1.5rem;
    flex-shrink: 0;
    user-select: none;
  }
`;

export const GlobalStyles = memo(() => (
  <>
    <Sheet />
    {/* eslint-disable-next-line react/no-danger */}
    <style dangerouslySetInnerHTML={{ __html: FontDefinition.join(' ') }} />
  </>
));
